/* tslint:disable */
/* eslint-disable */
/**
 * CoverCHILD REST API
 * REST API of the asset sourcing rfq service.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface DownloadLink {
    'id'?: string;
    'formName'?: string;
    'link': string;
}
export interface EvaluationRoutineLink {
    'id'?: string;
    'formName'?: string;
    'link': string;
}
export interface FileMetadata {
    'id'?: string;
    'name': string;
    'fileName': string;
    'type': FileMetadataTypeEnum;
    'createTimestamp'?: string;
}

export const FileMetadataTypeEnum = {
    Form: 'FORM',
    EvaluationRoutine: 'EVALUATION_ROUTINE'
} as const;

export type FileMetadataTypeEnum = typeof FileMetadataTypeEnum[keyof typeof FileMetadataTypeEnum];

export interface Instrument {
    'id'?: string;
    'name': string;
    'createTimestamp'?: string;
    'lastUpdateTimestamp'?: string;
    'publicationYear'?: number;
    'authors'?: string;
    'formOfSurvey'?: string;
    'targetDimension'?: string;
    'rater'?: string;
    'ageRange'?: string;
    'items'?: string;
    'processingTime'?: string;
    'openAccess'?: string;
    'diagnosticObjectiveOfTheAssessmentInstrument'?: string;
    'descriptionOfTheAssessmentInstrument'?: string;
    'notes'?: string;
    'languageVersions'?: string;
    'linkToAssessmentTool'?: string;
    'originalLiterature'?: string;
    'testDescriptionsAndReviews'?: string;
    'tagCategories': Array<TagCategory>;
    'psychometricParameterTypes': Array<PsychometricParameterType>;
    'links'?: Array<Links>;
    'downloadLinks': Array<DownloadLink>;
    'evaluationRoutineLink'?: Array<EvaluationRoutineLink>;
    'studyLinks'?: Array<StudyLinks>;
    'forms': Array<FileMetadata>;
    'evaluationRoutines': Array<FileMetadata>;
    'previousVersions': Array<InstrumentShortVersion>;
}
export interface InstrumentShortVersion {
    'id': string;
    'name': string;
}
export interface Links {
    'id'?: string;
    'formName'?: string;
    'link': string;
}
export interface ModelFile {
    'fileName': string;
    'data': string;
}
export interface PsychometricParameter {
    'id'?: string;
    'parameter'?: string;
    'approach'?: string;
    'results'?: string;
    'sample'?: string;
}
export interface PsychometricParameterType {
    'id': string;
    'name': string;
    'psychometricParameters'?: Array<PsychometricParameter>;
    'psychometricRecommendation'?: PsychometricParameterTypePsychometricRecommendationEnum;
}

export const PsychometricParameterTypePsychometricRecommendationEnum = {
    Red: 'RED',
    Yellow: 'YELLOW',
    Green: 'GREEN'
} as const;

export type PsychometricParameterTypePsychometricRecommendationEnum = typeof PsychometricParameterTypePsychometricRecommendationEnum[keyof typeof PsychometricParameterTypePsychometricRecommendationEnum];

export interface PsychometricParameterTypeShort {
    'id': string;
    'name': string;
}
export interface StudyLinks {
    'id'?: string;
    'formName'?: string;
    'link': string;
}
export interface Tag {
    'id'?: string;
    'name': string;
    'selected'?: boolean;
    'childTags'?: Array<Tag>;
}
export interface TagCategory {
    'id': string;
    'name': string;
    'tags': Array<Tag>;
}

/**
 * FilesApi - axios parameter creator
 */
export const FilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete one file.
         * @param {string} fileId The id of the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('deleteFile', 'fileId', fileId)
            const localVarPath = `/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download one file.
         * @param {string} fileId The id of the file to download
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('downloadFile', 'fileId', fileId)
            const localVarPath = `/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a file.
         * @param {FileMetadata} [metadata] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (metadata?: FileMetadata, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


            if (metadata !== undefined) { 
                localVarFormParams.append('metadata', new Blob([JSON.stringify(metadata)], { type: "application/json", }));
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesApi - functional programming interface
 */
export const FilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete one file.
         * @param {string} fileId The id of the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApi.deleteFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download one file.
         * @param {string} fileId The id of the file to download
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFile(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFile(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApi.downloadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a file.
         * @param {FileMetadata} [metadata] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(metadata?: FileMetadata, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(metadata, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApi.uploadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FilesApi - factory interface
 */
export const FilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete one file.
         * @param {string} fileId The id of the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFile(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download one file.
         * @param {string} fileId The id of the file to download
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadFile(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a file.
         * @param {FileMetadata} [metadata] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(metadata?: FileMetadata, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<FileMetadata> {
            return localVarFp.uploadFile(metadata, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FilesApi - object-oriented interface
 */
export class FilesApi extends BaseAPI {
    /**
     * 
     * @summary Delete one file.
     * @param {string} fileId The id of the file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFile(fileId: string, options?: RawAxiosRequestConfig) {
        return FilesApiFp(this.configuration).deleteFile(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download one file.
     * @param {string} fileId The id of the file to download
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadFile(fileId: string, options?: RawAxiosRequestConfig) {
        return FilesApiFp(this.configuration).downloadFile(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a file.
     * @param {FileMetadata} [metadata] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadFile(metadata?: FileMetadata, file?: File, options?: RawAxiosRequestConfig) {
        return FilesApiFp(this.configuration).uploadFile(metadata, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InstrumentsApi - axios parameter creator
 */
export const InstrumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new instrument.
         * @param {Instrument} [instrument] The instrument to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInstrument: async (instrument?: Instrument, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/instruments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(instrument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete one instruments.
         * @param {string} instrumentId The id of the instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInstrument: async (instrumentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instrumentId' is not null or undefined
            assertParamExists('deleteInstrument', 'instrumentId', instrumentId)
            const localVarPath = `/instruments/{instrumentId}`
                .replace(`{${"instrumentId"}}`, encodeURIComponent(String(instrumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one instruments.
         * @param {string} instrumentId The id of the instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (instrumentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instrumentId' is not null or undefined
            assertParamExists('getById', 'instrumentId', instrumentId)
            const localVarPath = `/instruments/{instrumentId}`
                .replace(`{${"instrumentId"}}`, encodeURIComponent(String(instrumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all instruments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstruments: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/instruments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update one instrument.
         * @param {string} instrumentId The id of the instrument
         * @param {Instrument} [instrument] The updated instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInstrument: async (instrumentId: string, instrument?: Instrument, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instrumentId' is not null or undefined
            assertParamExists('updateInstrument', 'instrumentId', instrumentId)
            const localVarPath = `/instruments/{instrumentId}`
                .replace(`{${"instrumentId"}}`, encodeURIComponent(String(instrumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(instrument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InstrumentsApi - functional programming interface
 */
export const InstrumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InstrumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new instrument.
         * @param {Instrument} [instrument] The instrument to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInstrument(instrument?: Instrument, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Instrument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInstrument(instrument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstrumentsApi.createInstrument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete one instruments.
         * @param {string} instrumentId The id of the instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInstrument(instrumentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInstrument(instrumentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstrumentsApi.deleteInstrument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get one instruments.
         * @param {string} instrumentId The id of the instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(instrumentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Instrument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(instrumentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstrumentsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all instruments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstruments(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Instrument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstruments(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstrumentsApi.getInstruments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update one instrument.
         * @param {string} instrumentId The id of the instrument
         * @param {Instrument} [instrument] The updated instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInstrument(instrumentId: string, instrument?: Instrument, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Instrument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInstrument(instrumentId, instrument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstrumentsApi.updateInstrument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InstrumentsApi - factory interface
 */
export const InstrumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InstrumentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new instrument.
         * @param {Instrument} [instrument] The instrument to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInstrument(instrument?: Instrument, options?: RawAxiosRequestConfig): AxiosPromise<Instrument> {
            return localVarFp.createInstrument(instrument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete one instruments.
         * @param {string} instrumentId The id of the instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInstrument(instrumentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteInstrument(instrumentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one instruments.
         * @param {string} instrumentId The id of the instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(instrumentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Instrument> {
            return localVarFp.getById(instrumentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all instruments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstruments(options?: RawAxiosRequestConfig): AxiosPromise<Array<Instrument>> {
            return localVarFp.getInstruments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update one instrument.
         * @param {string} instrumentId The id of the instrument
         * @param {Instrument} [instrument] The updated instrument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInstrument(instrumentId: string, instrument?: Instrument, options?: RawAxiosRequestConfig): AxiosPromise<Instrument> {
            return localVarFp.updateInstrument(instrumentId, instrument, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InstrumentsApi - object-oriented interface
 */
export class InstrumentsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new instrument.
     * @param {Instrument} [instrument] The instrument to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInstrument(instrument?: Instrument, options?: RawAxiosRequestConfig) {
        return InstrumentsApiFp(this.configuration).createInstrument(instrument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete one instruments.
     * @param {string} instrumentId The id of the instrument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteInstrument(instrumentId: string, options?: RawAxiosRequestConfig) {
        return InstrumentsApiFp(this.configuration).deleteInstrument(instrumentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one instruments.
     * @param {string} instrumentId The id of the instrument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getById(instrumentId: string, options?: RawAxiosRequestConfig) {
        return InstrumentsApiFp(this.configuration).getById(instrumentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all instruments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInstruments(options?: RawAxiosRequestConfig) {
        return InstrumentsApiFp(this.configuration).getInstruments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update one instrument.
     * @param {string} instrumentId The id of the instrument
     * @param {Instrument} [instrument] The updated instrument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateInstrument(instrumentId: string, instrument?: Instrument, options?: RawAxiosRequestConfig) {
        return InstrumentsApiFp(this.configuration).updateInstrument(instrumentId, instrument, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PsychometricApi - axios parameter creator
 */
export const PsychometricApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all available Psychometric Parameter Types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPsychometricParameterTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/psychometricParameterTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PsychometricApi - functional programming interface
 */
export const PsychometricApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PsychometricApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all available Psychometric Parameter Types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPsychometricParameterTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PsychometricParameterTypeShort>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPsychometricParameterTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PsychometricApi.getPsychometricParameterTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PsychometricApi - factory interface
 */
export const PsychometricApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PsychometricApiFp(configuration)
    return {
        /**
         * 
         * @summary List all available Psychometric Parameter Types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPsychometricParameterTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<PsychometricParameterTypeShort>> {
            return localVarFp.getPsychometricParameterTypes(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PsychometricApi - object-oriented interface
 */
export class PsychometricApi extends BaseAPI {
    /**
     * 
     * @summary List all available Psychometric Parameter Types.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPsychometricParameterTypes(options?: RawAxiosRequestConfig) {
        return PsychometricApiFp(this.configuration).getPsychometricParameterTypes(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TagsApi - axios parameter creator
 */
export const TagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all available search tags.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit search tags.
         * @param {Array<TagCategory>} [tagCategory] The search tags to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTags: async (tagCategory?: Array<TagCategory>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tagCategory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagsApi - functional programming interface
 */
export const TagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TagsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all available search tags.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TagCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTags(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.getTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit search tags.
         * @param {Array<TagCategory>} [tagCategory] The search tags to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTags(tagCategory?: Array<TagCategory>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TagCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTags(tagCategory, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TagsApi.updateTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TagsApi - factory interface
 */
export const TagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TagsApiFp(configuration)
    return {
        /**
         * 
         * @summary List all available search tags.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(options?: RawAxiosRequestConfig): AxiosPromise<Array<TagCategory>> {
            return localVarFp.getTags(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit search tags.
         * @param {Array<TagCategory>} [tagCategory] The search tags to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTags(tagCategory?: Array<TagCategory>, options?: RawAxiosRequestConfig): AxiosPromise<Array<TagCategory>> {
            return localVarFp.updateTags(tagCategory, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TagsApi - object-oriented interface
 */
export class TagsApi extends BaseAPI {
    /**
     * 
     * @summary List all available search tags.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTags(options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).getTags(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit search tags.
     * @param {Array<TagCategory>} [tagCategory] The search tags to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTags(tagCategory?: Array<TagCategory>, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).updateTags(tagCategory, options).then((request) => request(this.axios, this.basePath));
    }
}



